var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconBad(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_bad",
    transform: "translate(-139 -332)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_326",
    "data-name": "\\uD0C0\\uC6D0 326",
    cx: 23,
    cy: 23,
    r: 23,
    transform: "translate(139 332)",
    fill: "#ef6156",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_325",
    "data-name": "\\uD0C0\\uC6D0 325",
    cx: 16,
    cy: 16,
    r: 16,
    transform: "translate(146 339)",
    fill: "#ef6156"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2509",
    "data-name": "\\uD328\\uC2A4 2509",
    d: "M156.007,349.084l12,12",
    transform: "translate(-0.007 -0.084)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2510",
    "data-name": "\\uD328\\uC2A4 2510",
    d: "M156.007,349.084l12,12",
    transform: "translate(517.084 192.993) rotate(90)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 2
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBad);
export default __webpack_public_path__ + "static/media/icon_bad.804f8bb2539b009e1272f52ee3821c93.svg";
export { ForwardRef as ReactComponent };